module.exports = __webpack_public_path__ + "img/mieba.1f9746c1.png";